<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/accounting')" style="cursor: pointer">Contabilidad</li>
                <li class="breadcrumb-item active" aria-current="page">CUITF A6-B3</li>
            </ol>
        </nav>
    <div class="container-fluid">
      <vx-card title="Reportes CUITF A6-B3" class="mt-5" subtitle="Selecciona las opciones necesarias y presiona el botón 'Consultar'">
          <vs-row>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                <vs-select
                    class="w-full mb-4"
                    label="Mes de corte"
                    v-model.lazy="periodSelected"
                    name="periodSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index+1"
                    :text="item"
                    v-for="(item,index) in months"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                <vs-select
                    class="w-full mb-4"
                    label="Año"
                    v-model.lazy="yearSelected"
                    name="yearSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index"
                    :text="item"
                    v-for="(item,index) in years"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" vs-xs="12" class="ml-4">
                <div class="flex flex-wrap mt-6">
                    <vs-button color="success" @click="loadReports(false)" :disabled="loading">Consultar</vs-button>
                    <vs-button color="dark" class="ml-2" @click="loadReports(true)" :disabled="loading">Mostrar todos</vs-button>
                </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <h5 class="bold mt-5">Reportes generados</h5>
              <vs-table
                :sst="true"
                @sort="handleSort"
                ref="table"
                stripe
                :max-items="30"
                :data="allReports"
                noDataText="No hay datos disponibles"
                class="w-full"
              >
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                  <div class="pager" v-if="allReports.length > 0">
                    <div class="flex flex-wrap">
                      <vs-button
                        :disabled="allData.prev_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.prev_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-left"
                      ></vs-button>
                      <vs-button
                        v-if="allData.prev_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.first_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>1 ..</strong>
                      </vs-button>
                      <vs-button type="flat" text-color="dark" radius class="mr-2">
                        <strong>{{ allData.current_page }}</strong>
                      </vs-button>
                      <vs-button
                        v-if="allData.next_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.last_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>.. {{ allData.last_page }}</strong>
                      </vs-button>
                      <vs-button
                        :disabled="allData.next_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.next_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-right"
                      ></vs-button>
                    </div>
                  </div>
                  <!-- ITEMS PER PAGE -->
                  <div
                    v-if="totalRecords > 0"
                    class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th
                    class="bold"
                    v-for="(col, idx) in columns"
                    v-bind:key="idx"
                    :sort-key="col.sortable ? col.key : null"
                  >{{col.title}}</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>{{ midDateFormat(tr.report_date) }}</vs-td>
                    <vs-td><vs-button size="small" color="success" type="filled" icon="download" :disabled="tr.file_name == null" @click="downloadFile(tr)">Descargar</vs-button></vs-td>
                    <template slot="expand">
                        <vs-row>
                            <vs-col vs-lg="5">
                                <vs-row>
                                    <vx-card title="Cartera vigente" class="mr-2">
                                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                                            <vs-list>
                                                <vs-list-header title="Créditos sin pagos vencidos" color="dark"></vs-list-header>
                                                <vs-list-item :title="'Capital: '+explicitMoneyFormat(tr.cartera_vigente_sin_pagos_vencidos_capital)"></vs-list-item>
                                                <vs-list-item :title="'Intereses: '+explicitMoneyFormat(tr.cartera_vigente_sin_pagos_vencidos_intereses)"></vs-list-item>
                                                <vs-list-item :title="'Total: '+explicitMoneyFormat(tr.total_sin_vencidos)"></vs-list-item>
                                            </vs-list>
                                        </vs-col>
                                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                                            <vs-list>
                                                <vs-list-header title="Créditos en incumplimiento" color="dark"></vs-list-header>
                                                <vs-list-item :title="'Capital: '+explicitMoneyFormat(tr.cartera_vigente_en_incumplimiento_capital)"></vs-list-item>
                                                <vs-list-item :title="'Intereses: '+explicitMoneyFormat(tr.cartera_vigente_en_incumplimiento_intereses)"></vs-list-item>
                                                <vs-list-item :title="'Total: '+explicitMoneyFormat(tr.total_en_cumplimiento)"></vs-list-item>
                                            </vs-list>
                                        </vs-col>
                                    </vx-card>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-lg="4">
                                <vs-row>
                                    <vx-card title="Cartera vencida" class="mr-2">
                                        <vs-col vs-lg="12">
                                            <vs-list>
                                                <vs-list-header title="+90 dias" color="dark"></vs-list-header>
                                                <vs-list-item :title="'Capital: '+explicitMoneyFormat(tr.cartera_vencida_capital)"></vs-list-item>
                                                <vs-list-item :title="'Intereses: '+explicitMoneyFormat(tr.cartera_vencida_intereses)"></vs-list-item>
                                                <vs-list-item :title="'Total: '+explicitMoneyFormat(tr.total_cartera_vencida)"></vs-list-item>
                                            </vs-list>
                                        </vs-col>
                                    </vx-card>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-lg="3">
                                <vs-row>
                                    <vx-card title="Cartera Total">
                                        <vs-col vs-lg="12">
                                            <vs-list>
                                                <vs-list-header title="Resumen" color="dark"></vs-list-header>
                                                <vs-list-item :title="'Cartera vigente: '+explicitMoneyFormat(tr.total_cartera_vigente)"></vs-list-item>
                                                <vs-list-item :title="'Cartera vencida: '+explicitMoneyFormat(tr.total_cartera_vencida)"></vs-list-item>
                                                <vs-list-item :title="'Total: '+explicitMoneyFormat(tr.total_carteras)"></vs-list-item>
                                            </vs-list>
                                        </vs-col>
                                    </vx-card>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                    </template>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-col>
          </vs-row>
      </vx-card>
    </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import dateHelper from "@mixins/dateHelper";
    import formatHelper from "@mixins/formatHelper";
    const columnDefinitions = [
        { title: "ID", key: "id", sortable: false },
        { title: "Fecha de creación", key: "report_date", sortable: true },
        { title: "Archivo", key: "file_name", sortable: true }
    ];
    export default {
        name: "ReportCuitfA6B3.vue",
        mixins: [dateHelper,formatHelper],
        computed: {
            ...mapState('auth', ['user']),
            allReports() {
                return this.allData.data;
            },
            from() {
                return this.allData.from;
            },
            to() {
                return this.allData.to;
            },
            totalRecords() {
                return this.allData.total;
            }
        },
        data: () => ({
            loading: false,
            months: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
            years: ["2020","2021","2022","2023"],
            periodSelected: 1,
            yearSelected: 0,
            allData: {
                data: [],
                from: null,
                to: null,
                total: 0
            },
            columns: columnDefinitions,
        }),
        async mounted() {
            await this.loadReports();
        },
        methods: {
            async loadReports(showAll = true, url = '/api/accounting/reportCuitfA6B3/all/all') {
                this.showLoading(true);
                if (showAll === false) {
                    var year = this.years[this.yearSelected];
                    url = `/api/accounting/reportCuitfA6B3/${this.periodSelected}/${year}`;
                }
                try {
                    const response = await axios.get(url);
                    this.allData = response.data;
                    this.allReports.forEach(report => {
                        report.total_sin_vencidos = report.cartera_vigente_sin_pagos_vencidos_capital+report.cartera_vigente_sin_pagos_vencidos_intereses;
                        report.total_en_cumplimiento = report.cartera_vigente_en_incumplimiento_capital+report.cartera_vigente_en_incumplimiento_intereses;
                        report.total_cartera_vigente = report.total_sin_vencidos+report.total_en_cumplimiento;
                        report.total_cartera_vencida = report.cartera_vencida_capital+report.cartera_vencida_intereses;
                        report.total_carteras = report.total_cartera_vigente+report.total_cartera_vencida;
                    });
                    this.showLoading(false);
                } catch (e) {
                this.showLoading(false);
                    this.errorNotif("Aviso", e.response.data.message, 4000);                
                }
            },
            async handleSort(key, active) {
                if (key === "report_date") {
                    this.allReports.sort(function (a, b) {
                        return (
                            Number(new Date(a.report_date)) - Number(new Date(b.report_date))
                        );
                    });
                }
            },
            async pager(url) {
                await this.loadReports(null,url);
            },
            downloadFile(report) {
                window.open(`${this.ApiDomain}/api/downloadCuitfA6B3Report/${report.id}?access_token=${this.AccessToken}`, "_blank");
            },
        }
    }
</script>